export default __webpack_public_path__ + "static/media/invisible.9190688b.png";